export const actionColors: Array<string> = [
	'#dd9933',
	'#67074e',
	'#5a175d',
	'#074e67',
	'#05878a',
	'#c9c1e7',
	'#bdd5ef',
	'#c7e3d0',
	'#e7e6ce',
	'#f2d8cc',
	'#e9ccce',
];
